// Use numerical codes and start with 10000 to not mix them with the HTTP codes.
export const CVV_MISSING_ERROR_CODE = 10001;
export const CVV_INCORRECT_ERROR_CODE = 10002;
export const NOT_FOR_SALE_MEMBERSHIP_ERROR_CODE = 11001;
export const NOT_FOR_SALE_CODE = 11001;
export const NOT_ACTIVE_MEMBERSHIP_ERROR_CODE = 11002;
